export function isLoggedIn() {
    return jQuery('body').hasClass('logged-in');
}

export function isMobileScreen() {
    return window.outerWidth < 1260;
}

export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function onClickOutside(selector, cb) {
    const outsideClickListener = (event) => {
        let $target = $(event.target);
        if (!$target.closest(selector).length && $(selector).is(':visible')) {
            let handled = cb();
            if (handled) {
                removeClickListener();
            }
        }
    }

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener)
    }

    document.addEventListener('click', outsideClickListener)
}